import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { BreadcrumbModule } from 'xng-breadcrumb';
import {
  FormFieldCheckboxGdprComponent,
  FormFieldCheckboxTermsOfServiceComponent,
  FormFieldSelectionTestLocationComponent,
  TestTimeCardComponent,
} from '../components';
import { ParentalAddressFormComponent } from '../components/forms/exam-booking/sdv';
import { FormFieldsModule } from '../lib/form-fields/form-fields.module';
import { LoadingIndicatorFullComponent } from '../lib/misc';
import { ConsentProctoringPageComponent } from '../pages';
import { NG_MODULES } from './ng-modules';
import { NGX_TRANSLATE_CONFIG } from './ngx-translate-config';

@NgModule({
  declarations: [
    ConsentProctoringPageComponent,
    FormFieldCheckboxGdprComponent,
    FormFieldCheckboxTermsOfServiceComponent,
    FormFieldSelectionTestLocationComponent,
    LoadingIndicatorFullComponent,
    ParentalAddressFormComponent,
    TestTimeCardComponent,
  ],
  imports: [
    ...NG_MODULES,
    BreadcrumbModule,
    CommonModule,
    NGX_TRANSLATE_CONFIG,
    FormFieldsModule,
    NgSelectModule,
  ],
  exports: [
    ...NG_MODULES,
    BreadcrumbModule,
    CommonModule,
    ConsentProctoringPageComponent,
    FormFieldCheckboxGdprComponent,
    FormFieldCheckboxTermsOfServiceComponent,
    FormFieldSelectionTestLocationComponent,
    LoadingIndicatorFullComponent,
    ParentalAddressFormComponent,
    TestTimeCardComponent,
    FormFieldsModule,
  ],
})
export class SharedModule {}
